import {
    Button,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown
} from "reactstrap";

import Avatar from "@components/ui-components/avatar";
import { UserContext } from "@context/user";
import { useContext } from "react";
import useLogout from "@hooks/use-logout";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getItemFromStore, isSuperAdminUrl, loginViaSuperadmin } from "@src/utility/helpers/utils";
import { PanelDefaultRoute, SuperAdminDefaultRoute } from "@src/router/routes";
import size from "lodash/size";

export const CommonNavOptions = () => {
    const { handleLogout } = useLogout();
    const navigate = useNavigate();
    if (isSuperAdminUrl()) {
        return [
            {
                id     : "log-out",
                title  : "Logout",
                icon   : "logout",
                tag    : "div",
                show   : true,
                onClick: handleLogout
            }
        ];
    }
    return [
        {
            id     : "users",
            title  : "Users",
            icon   : "account-multiple",
            tag    : "div",
            show   : true,
            onClick: () => navigate("/account/users")
        },
        {
            id     : "account",
            title  : "My Account",
            icon   : "account-circle",
            tag    : "div",
            show   : true,
            onClick: () => navigate("/account/myaccount")
        },
        {
            id     : "log-out",
            title  : "Logout",
            icon   : "logout",
            tag    : "div",
            show   : true,
            onClick: handleLogout
        }
    ];
};

export const BackPanel = () => {
    const handleBackToButton = () => {
        const adminToken = getItemFromStore("token");
        const superadminToken = getItemFromStore("token-superadmin");

        if (loginViaSuperadmin()) {
            if (!isSuperAdminUrl()) {
                return {
                    isSuperadmin: true,
                    to          : SuperAdminDefaultRoute,
                    text        : "Back to SA",
                    icon        : "left"
                };
            }

            if (isSuperAdminUrl() && adminToken && superadminToken) {
                return {
                    isSuperadmin: false,
                    to          : PanelDefaultRoute,
                    text        : "Back to panel",
                    icon        : "right"
                };
            }
        } else {
            return {};
        }
    };

    const handleBackTo = () => {
        const { to } = handleBackToButton();
        if (to) {
            window.location.href = to;
        }
    };

    return (
        <>
            {size(handleBackToButton()) ? (
                <Button
                    color="danger"
                    className="d-flex align-items-center text-nowrap w-max btn-sm"
                    onClick={() => handleBackTo()}>
                    <i
                        className={`mdi mdi-arrow-${handleBackToButton().icon}`}/>
                    <b className="d-lg-block d-none">
                        {handleBackToButton().text}
                    </b>
                </Button>
            ) : null}
        </>
    );
};

export const PanelUserDropdown = () => {
    const { t } = useTranslation();
    const { userData: {
        user: { name, image, email } = {} } = {} } = useContext(UserContext);
    return (
        <UncontrolledDropdown
            direction="down"
            data-cy="user-dropdown"
            className="d-flex align-items-center profile-menu">
            <DropdownToggle
                href="/"
                tag="a"
                className="nav-link dropdown-user-link"
                onClick={e => e.preventDefault()}>
                <Avatar
                    img={image}
                    initials={!image}
                    content={name || email || "User"}
                    color="primary"
                    light={false}
                    className="cursor-pointer"
                    rounded/>
            </DropdownToggle>
            <DropdownMenu className="m-auto w-max">
                {CommonNavOptions().map(option => {
                    return (
                        option.show && (
                            <DropdownItem
                                {...(option.onClick ? { onClick: option.onClick } : {})}
                                className="py-25 px-1 d-flex align-items-center"
                                {...(option.tag ? { tag: option.tag } : {})}
                                data-cy={`${option.id}-btn`}
                                {...(option.target ? { target: option.target } : {})}
                                {...(option.to ? { to: option.to } : {})}
                                key={option.id}>
                                <i className={`mdi mdi-${option.icon} font-medium-3 pe-75`} />
                                {t(option.title)}
                            </DropdownItem>
                        )
                    );
                })}                
            </DropdownMenu>
        </UncontrolledDropdown>
    );
};

